enum CardIssuer {
  STRIPE = "STRIPE",
  HIGHNOTE = "HIGHNOTE",
  CORPAY = "CORPAY",
}

export default CardIssuer;
